export enum PrivOffExperience {
    PoE1 = 1,
    PoE2 = 2,
    PoE3 = 3,
    PoE4 = 4,
    PoE5 = 5,
}
